// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsInt, IsNotEmpty, IsString, ValidateNested } from 'class-validator';

class LibraryForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class SymbolForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @ValidateNested()
  library: LibraryForm;
}
